/**
 * A fixed value typed as text and read as JSON where it is JSON: `3` is a
 * number, `true` a boolean, `["a"]` a list, and anything else, `chat` say,
 * is the string itself. A string that would read as something else is
 * shown quoted, so it stays a string when it is committed again.
 */
import { useEffect, useState } from 'react';

import { Input } from '../../ui/finixt.js';

export function parseValue(text: string): unknown {
  try {
    return JSON.parse(text) as unknown;
  } catch {
    return text;
  }
}

export function showValue(value: unknown): string {
  if (value === undefined || value === null) return value === null ? 'null' : '';
  if (typeof value === 'string') return parseValue(value) === value ? value : JSON.stringify(value);
  return JSON.stringify(value);
}

export function ValueInput({
  value,
  onChange,
  label,
}: {
  value: unknown;
  onChange: (value: unknown) => void;
  label: string;
}) {
  const [text, setText] = useState(showValue(value));
  useEffect(() => setText(showValue(value)), [value]);
  const commit = () => {
    const next = parseValue(text);
    if (JSON.stringify(next) !== JSON.stringify(value)) onChange(next);
  };
  return (
    <Input
      aria-label={label}
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit();
      }}
    />
  );
}
